import { styled } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const SmallMuiXDatePicker = styled(DatePicker)(({ theme, fontColor }) => ({
    '& .MuiOutlinedInput-root': {
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: fontColor, // Change border color here
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: fontColor, // Change border color on hover
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: fontColor, // Change border color when focused
        },
    },
    '& .MuiInputLabel-root': {
        color: fontColor, // Change label color here
    },
    '& .MuiInputBase-input': {
        padding: '0px 12px',  // Example: Smaller padding
        height: 30,       // Example: Adjust height
        fontSize: '0.875rem', // Example: Smaller font size
        color: fontColor
    },
    '.MuiSvgIcon-root': {
        fontSize: '1rem', // Example: Smaller font size
        color: fontColor, // Change label color here
    },
}));

export default SmallMuiXDatePicker;